import React__default, { useRef, useState, useEffect } from 'react';
import styles from './TextTruncate.module.css.js';
import Button from '../../Forms/Button/Button.js';

const TextTruncate = ({ children, width, lines = 1, showMoreText = false, showLessText = false, moreText = 'Read more', lessText = 'Read less', }) => {
    const containerRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const [isOriginallyTruncated, setIsOriginallyTruncated] = useState(false);
    const [isMeasured, setIsMeasured] = useState(false);
    useEffect(() => {
        setIsMeasured(false);
        setTimeout(() => {
            const element = containerRef.current;
            if (element && element.scrollHeight > element.clientHeight) {
                setIsTruncated(true);
                setIsOriginallyTruncated(true);
            }
            else {
                setIsTruncated(false);
                setIsOriginallyTruncated(false);
            }
            setIsMeasured(true);
        }, 100);
    }, [children, width, lines]);
    const handleClick = () => {
        setIsTruncated(!isTruncated);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: isMeasured
                ? !isTruncated
                    ? styles.textNotTruncate
                    : styles.textTruncate
                : styles.textTruncate, 
            /*   className={styles.textTruncate} */
            style: { width: width, WebkitLineClamp: lines }, ref: containerRef }, children),
        isTruncated && showMoreText ? (React__default.createElement(Button, { onClick: handleClick, type: "link", allCaps: false }, moreText)) : isOriginallyTruncated && !isTruncated && showLessText ? (React__default.createElement(Button, { onClick: handleClick, type: "link", allCaps: false }, lessText)) : null));
};

export { TextTruncate as default };
//# sourceMappingURL=TextTruncate.js.map
